import { useEffect, useState, useLayoutEffect } from "react";
import { useDebounce } from "use-debounce";

import * as JsSearch from "js-search";

import { SearchInput } from "./components/Input";
import { Header } from "./components/Header";
import { Item } from "./components/Item";
import { SocialButton, TwitterIcon } from "./components/Button";

const URL = process.env.REACT_APP_URL;

const stemmer = require("porter-stemmer").stemmer;
const search = new JsSearch.Search("id");
search.tokenizer = new JsSearch.StemmingTokenizer(
  stemmer,
  new JsSearch.SimpleTokenizer()
);

function App() {
  const [twitterUsers, setTwitterUsers] = useState(
    localStorage.getItem("following") || ""
  );
  const [count, setCount] = useState(localStorage.getItem("countUsers") || "0");

  const url = window.location.search;
  const querySearch = new URLSearchParams(url).get("s") || "";

  const [query, setQuery] = useState(querySearch);
  const [result, setResult] = useState([]);
  const [queryDebounce] = useDebounce(query, 50);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  search.addIndex("name");
  search.addIndex("screen_name");
  search.addIndex("description");
  search.addIndex("location");

  const logOut = () => {
    localStorage.removeItem("following");
    setTwitterUsers("");
    // Call nodejs to delete session
  };

  const reSync = () => {
    localStorage.removeItem("following");
    window.location.href = `${URL}/auth/twitter`;
  };

  const updateSearch = () => {
    console.log("q?");
    if (twitterUsers !== "") {
      let doc = JSON.parse(twitterUsers);
      //console.log(doc);
      search.addDocuments(doc);
      console.log(search);
      setResult(search.search(query));
    }
  };

  useLayoutEffect(() => {
    console.log("FIRST PAINT");
    async function fetchData() {
      console.log("FETCH DATA");
      setLoading(true);

      const response = await fetch(`${URL}/getFriends`);
      const data = await response.json();

      if (!data.error) {
        setCount(JSON.stringify(data.length));
        localStorage.setItem("countUsers", JSON.stringify(data.length));

        setTwitterUsers(JSON.stringify(data));
        localStorage.setItem("following", JSON.stringify(data));
      } else {
        setLoading(false);
        setError(data.error);
      }
    }

    if (twitterUsers === "") {
      fetchData();
    }
    // } else {
    //   updateSearch();
    // }
  }, []); // Or [] if effect doesn't need props or state

  useEffect(() => {
    setResult(search.search(queryDebounce));
  }, [queryDebounce]);

  useEffect(() => {
    console.log("Update");
    updateSearch();
  }, [twitterUsers]);

  // useEffect(() => {
  //   if (twitterUsers === "") return;
  // }, [twitterUsers]);

  return (
    <div className="App">
      <Header isLogged={twitterUsers !== ""} logOut={logOut} reSync={reSync} />
      <div className="wrapper">
        {error && error !== "no twitter token" && error}

        {twitterUsers !== "" ? (
          <>
            <SearchInput
              spellcheck="false"
              autocapitalize="false"
              placeholder={`Search ${count} following people...`}
              autoFocus
              className="headline"
              onChange={(e) => {
                setQuery(e.target.value);
                window.history.replaceState(null, null, `?s=${e.target.value}`);
              }}
              value={query}
            />

            <div className="resultWrapper">
              {result.length > 0 && result.map((e) => <Item data={e} />)}

              {result.length <= 0 && query !== "" && <div>No Results</div>}
            </div>
          </>
        ) : (
          <div>
            {loading === true ? (
              <h1 className="headline">Downloading your data...</h1>
            ) : (
              <div className="home">
                {/* <GradientCircle /> */}
                {/* <h1 className="headline start">
                  Sync your accounts and unlock a better search for who you
                  follow
                </h1> */}
                <SocialButton href={`${URL}/auth/twitter`}>
                  <TwitterIcon width={24} height={24} color="#fff" />
                  Sync Twitter
                </SocialButton>

                <a
                  href="https://chrome.google.com/webstore/detail/twitter-search/kicoaaaemngohpfklndinjafjeakdilb?hl=en&authuser=0"
                  className="exLink"
                >
                  and install the extension
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
